import React from "react";

const ACCENT = "#1565C0";

export const REFRESH_TIMES = [
  { start: "7:00:00 AM", end: "7:30:00 AM" },
  { start: "8:00:00 AM", end: "8:30:00 AM" },
  { start: "9:00:00 AM", end: "9:30:00 AM" },
  { start: "10:00:00 AM", end: "10:30:00 AM" },
  { start: "11:00:00 AM", end: "11:30:00 AM" },
  { start: "12:00:00 PM", end: "12:30:00 PM" },
  { start: "1:00:00 PM", end: "1:30:00 PM" },
  { start: "2:00:00 PM", end: "2:30:00 PM" },
  { start: "3:00:00 PM", end: "3:30:00 PM" },
  { start: "4:00:00 PM", end: "4:30:00 PM" },
  { start: "5:00:00 PM", end: "5:30:00 PM" },
  { start: "6:00:00 PM", end: "6:30:00 PM" },
];

export const REPORT_SECTIONS = [
  {
    label: "Financial Analysis",
    reports: [
      {
        label: "P&L by Program",
        key: "pl_by_program",
        icon: "financial",
        description: "Executive Summary Reporting, Multiple Views",
        frequency: "monthly",
      },
      {
        label: "Waterfall / EAC",
        key: "waterfall_eac",
        icon: "waterfall",
        description: "Executive Report With Details by Project",
        frequency: "monthly",
      },
      {
        label: "Labor Utilization",
        key: "labor_utilization",
        icon: "labor",
        description: "Direct Labor Hours by Person and Business Unit",
        frequency: "weekly",
      },
      {
        label: "Monthly T&M Hours Report",
        key: "monthly_tm_hours",
        icon: "hours",
        description: "T&M Projects — Hours and Revenue by Month",
        frequency: "monthly",
      },
      {
        label: "T&M Profitability",
        key: "tm_profitability",
        icon: "profit",
        description:
          "Monthly Hours, Cost and GP by Person, by Project, by Month for T&M",
        frequency: "monthly",
      },
      {
        label: "FTE Report (New Hire Plan)",
        key: "fte_report",
        icon: "labor",
        description:
          "Current FTE Mix (Employee / IWO / Subcontractor) and the Planned New-Hire Forecast",
        frequency: "monthly",
      },
    ],
  },
  {
    label: "Scenario & Forecast",
    reports: [
      {
        label: "Monthly Report by Scenario (DFR Format)",
        key: "monthly_dfr",
        icon: "scenario",
        description: "Monthly Financials by Project (Rev, Cost, Profit)",
        frequency: "monthly",
      },
      {
        label: "Project Management Reviews",
        key: "pm_reviews",
        icon: "review",
        description:
          "Multiple Financial Performance Reports, Rolled Up by Project",
        frequency: "monthly",
      },
      {
        label: "Scenario Comparison Month over Month",
        key: "scenario_mom",
        icon: "compare",
        description:
          "Current Forecast Compared to Budget & Prior Forecast Future — Allow User to Choose Which Forecast Scenario to Compare",
        frequency: "monthly",
      },
      {
        label: "Scenario Comparison YoY",
        key: "scenario_yoy",
        icon: "compare",
        description: "Fiscal Year 2025 Vs 2026 Comparison by Project",
        frequency: "monthly",
      },
      {
        label: "Forecast Monthly Summary",
        key: "forecast_monthly",
        icon: "forecast",
        description:
          "Monthly Forecast in Table Form, Filter by Forecast (EAC8, EAC9, Etc.)",
        frequency: "monthly",
      },
    ],
  },
  {
    label: "Operations & Indirect",
    reports: [
      {
        label: "Heatmap",
        key: "heatmap",
        icon: "heatmap",
        description: "Color Chart for the Monthly BU Financial Reviews (BUFRs)",
        frequency: "monthly",
      },
      {
        label: "Funding Expenditure",
        key: "funding_expenditure",
        icon: "funding",
        description:
          "Graphical Depiction of Funding Compared to Spend Plan Future — Needs Enhancements",
        frequency: "monthly",
      },
      {
        label: "Exception Report",
        key: "exception_report",
        icon: "exception",
        description: "Employee-Wise Revenue With No Cost",
        frequency: "weekly",
      },
      {
        label: "L2 Tech II Heatmap Report",
        key: "l2_tech_heatmap",
        icon: "heatmap",
        description: "Color Chart for the Monthly BU Financial Reviews (BUFRs)",
        frequency: "monthly",
      },
      {
        label: "Indirect Report",
        key: "indirect_report",
        icon: "indirect",
        description: "Dashboards for Indirect Analysis",
        frequency: "monthly",
      },
    ],
  },
  {
    label: "Contract & Budget",
    reports: [
      {
        label: "AOP Budget",
        key: "aop_budget",
        icon: "aop_plan",
        description: "Annual Operating Plan — Budget vs Current Forecast by Component",
        frequency: "annual",
      },
      {
        label: "Variance Report",
        key: "summary_vs_budget",
        icon: "budget",
        description: "Contract-Level Actuals Compared to Budget by Period",
        frequency: "monthly",
      },
      {
        label: "Contract Notes",
        key: "contract_notes",
        icon: "notes",
        description: "Project Notes and Comments by Contract",
        frequency: "monthly",
      },
      {
        label: "Adjusted Bill Rate",
        key: "adjusted_bill_rate",
        icon: "billrate",
        description: "Adjusted Bill Rate Analysis by Employee and Project",
        frequency: "monthly",
      },
    ],
  },
];

export const ALL_REPORTS = REPORT_SECTIONS.flatMap((s) => s.reports);

export function getReportUrl(key) {
  const envMap = {
    pl_by_program: process.env.BI_REPORT_PL_PROGRAM,
    waterfall_eac: process.env.BI_REPORT_WATERFALL_EAC,
    labor_utilization: process.env.BI_REPORT_LABOR_UTIL,
    monthly_tm_hours: process.env.BI_REPORT_MONTHLY_TM_HOURS,
    tm_profitability: process.env.BI_REPORT_TM_PROFITABILITY,
    monthly_dfr: process.env.BI_REPORT_MONTHLY_DFR,
    pm_reviews: process.env.BI_REPORT_PM_REVIEWS,
    scenario_mom: process.env.BI_REPORT_SCENARIO_MOM,
    scenario_yoy: process.env.BI_REPORT_SCENARIO_YOY,
    forecast_monthly: process.env.BI_REPORT_FORECAST_MONTHLY,
    heatmap: process.env.BI_REPORT_HEATMAP,
    funding_expenditure: process.env.BI_REPORT_FUNDING_EXP,
    exception_report: process.env.BI_REPORT_EXCEPTION,
    l2_tech_heatmap: process.env.BI_REPORT_L2_TECH_HEATMAP,
    indirect_report: process.env.BI_REPORT_INDIRECT,
    aop_budget: process.env.BI_REPORT_AOP_BUDGET,
    summary_vs_budget: process.env.BI_REPORT_SUMMARY_VS_BUDGET,
    contract_notes: process.env.BI_REPORT_CONTRACT_NOTES,
    adjusted_bill_rate: process.env.BI_REPORT_ADJUSTED_BILL_RATE,
  };
  return envMap[key] || process.env.BI_REPORTS_URL;
}

export const REPORT_ICONS = {
  financial: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ),
  waterfall: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="14" width="4" height="6" />
      <rect x="8" y="9" width="4" height="11" />
      <rect x="14" y="5" width="4" height="15" />
      <rect x="20" y="11" width="2" height="9" />
      <polyline points="2,14 6,8 14,5 20,11" />
    </svg>
  ),
  labor: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  hours: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  profit: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  ),
  scenario: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <line x1="9" y1="3" x2="9" y2="21" />
    </svg>
  ),
  review: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  compare: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="17 1 21 5 17 9" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <polyline points="7 23 3 19 7 15" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  ),
  forecast: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
      <line x1="2" y1="20" x2="22" y2="20" />
    </svg>
  ),
  heatmap: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="5" height="5" rx="1" />
      <rect x="10" y="3" width="5" height="5" rx="1" />
      <rect x="17" y="3" width="5" height="5" rx="1" />
      <rect x="3" y="10" width="5" height="5" rx="1" />
      <rect x="10" y="10" width="5" height="5" rx="1" />
      <rect x="17" y="10" width="5" height="5" rx="1" />
      <rect x="3" y="17" width="5" height="5" rx="1" />
      <rect x="10" y="17" width="5" height="5" rx="1" />
      <rect x="17" y="17" width="5" height="5" rx="1" />
    </svg>
  ),
  funding: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    </svg>
  ),
  exception: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  indirect: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 12 12 17 22 12" />
      <polyline points="2 17 12 22 22 17" />
    </svg>
  ),
  budget: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  ),
  notes: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  billrate: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ),
  aop_plan: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ACCENT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1" fill={ACCENT} stroke="none" />
    </svg>
  ),
};
